import { render, staticRenderFns } from "./ToggleApprovalAutomationBlockBtn.vue?vue&type=template&id=45ae70f9&"
import script from "./ToggleApprovalAutomationBlockBtn.vue?vue&type=script&lang=js&"
export * from "./ToggleApprovalAutomationBlockBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports